// extracted by mini-css-extract-plugin
export default {"fields":"qFETuc","gaps":"nvyT6K","time":"fzEfdd","mobile":"gyKkuK"};